import { UserData } from '../OrdersPage/types';

export interface LoginState {
  errorMessage: string | null;
  errorCode: string | null;
  error: string | null;
  loading: boolean;
  accessToken: string | null;
  refreshToken: string | null;

  userData: {
    data: any;
    error: null | string;
    loading: boolean;
  };

  authWhatsappNumber: string;
  submited: boolean;
  warning: {
    ru: string;
    kz: string;
    type: string;
  } | null;
}

export interface UserResponse {
  result: UserData;
}

export interface TelegramAuthData {
  id_token: string;
  user: {
    id: number;
    name: string;
    preferred_username?: string;
    picture?: string;
    phone_number?: string;
  };
  error?: string;
}

export enum ErrorCodeList {
  A401004 = 'A401004',
}
